import { useTranslation } from 'react-i18next'

import { deliveryMethodNames as deliveryMethodLabels } from '@reveni-io/reveni-ui'

import { iconsByType } from './constants'
import * as Styles from './styles'

const DeliveryMethodLabel = ({ deliveryMethod }) => {
  const Icon = iconsByType[deliveryMethod.type]
  const label = deliveryMethodLabels[deliveryMethod.type]
  const { t } = useTranslation()

  return (
    <Styles.MainContainer>
      <Icon size={20} />
      {deliveryMethod?.carrier_service?.logo_url && (
        <img height={20} src={deliveryMethod.carrier_service.logo_url} alt={deliveryMethod.carrier_service.name} />
      )}
      {deliveryMethod?.internal_id} | {deliveryMethod?.internal_name || t(label)}{' '}
      {deliveryMethod?.carrier_service?.name && `(${deliveryMethod?.carrier_service?.name})`}
    </Styles.MainContainer>
  )
}

export default DeliveryMethodLabel
